import React, { FC, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid,
    LinearProgress,
    Fade,
    Box,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import LcwMoneyCommand from '../../../services/command/lcwmoney/LcwMoney.services';

import { NumericFormat } from 'react-number-format';

interface CashInOutE2EClasses {
    dialogPaper?: string;
    dialogTitle?: string;
    progressWrap?: string;
    dialogContent?: string;
    amountFieldWrap?: string;
    numericAmount?: string;
    description?: string;
    reference?: string;
    radioWrap?: string;
    radioAdd?: string;
    radioRemove?: string;
    dialogActions?: string;
    saveButton?: string;
    cancelButton?: string;
}

interface IProps {
    open?: boolean;
    onClose?: any;
    refresh?: any;
    customerId?: any;
    balance?: any;
    /** Stable classes for E2E */
    e2eClassNames?: CashInOutE2EClasses;
}

export const SCUIAddLcwMoneyCashInOut: FC<IProps> = ({
    open = false,
    onClose,
    refresh,
    customerId,
    balance,
    e2eClassNames: e2e,
}) => {
    const [description, setDescription] = useState('');
    const [value, setValue] = useState('1');
    const [reference, setReference] = useState('');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const handleChangeDescription = (event: any) => {
        setDescription(event.target.value);
    };
    const handleChangeReferenceNumber = (event: any) => {
        setReference(event.target.value);
    };
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };
    const [inputValue, setInputValue] = useState(0);
    const { t } = useTranslation();

    const CreateLcwMoney = async () => {
        setLoading(true);
        let params = null;
        params = {
            CustomerId: customerId,
            Description: description,
            ReferenceNumber: reference,
            Amount: value === '2' ? inputValue * -1 : inputValue,
        };
        if (reference?.trim().length > 0 && customerId > 0 && description?.trim()?.length > 0) {
            LcwMoneyCommand.LcwMoneyCashInOut(params)
                .then(() => {
                    setLoading(false);
                    refresh();
                    Swal.fire(t('general.success'), ' ', 'success');
                    setInputValue(0);
                    setDescription('');
                    setReference('');
                    setShow(false);
                })
                .catch((error: any) => {
                    setShow(false);
                    setLoading(false);
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setShow(false);
                    setInputValue(0);
                    setLoading(false);
                });
        } else {
            setLoading(false);
            setShow(false);
            Swal.fire(t('lcwMoney.noEmpty'), ' ', 'error');
        }
    };

    const submitHandler = (event: any) => {
        setShow(true);
        event.preventDefault();
        CreateLcwMoney();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    ...(e2e?.dialogPaper ? { className: e2e.dialogPaper } : {}),
                },
            }}
        >
            <DialogTitle className={e2e?.dialogTitle}>{t('lcwMoney.addRemove')}</DialogTitle>
            <Box className={e2e?.progressWrap}>
                <Fade in={loading} unmountOnExit>
                    <LinearProgress />
                </Fade>
            </Box>
            <form onSubmit={submitHandler}>
                <DialogContent className={e2e?.dialogContent}>
                    <div className={e2e?.amountFieldWrap}>
                        <NumericFormat
                            className={e2e?.numericAmount}
                            value={inputValue}
                            onValueChange={(values: any) => {
                                setInputValue(values.floatValue);
                            }}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            customInput={TextField}
                            fullWidth
                            variant="standard"
                        />
                    </div>

                    <TextField
                        className={e2e?.description}
                        margin="dense"
                        id="link"
                        label={t('lcwMoney.description')}
                        fullWidth
                        variant="standard"
                        onChange={handleChangeDescription}
                    />

                    <TextField
                        className={e2e?.reference}
                        margin="dense"
                        id="link"
                        label={t('lcwMoney.referenceNumber')}
                        fullWidth
                        variant="standard"
                        onChange={handleChangeReferenceNumber}
                    />

                    <Grid direction={'row'} className={e2e?.radioWrap}>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={value}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    className={e2e?.radioAdd}
                                    value="1"
                                    control={<Radio />}
                                    label={t('general.add')}
                                />
                                <FormControlLabel
                                    className={e2e?.radioRemove}
                                    value="2"
                                    control={<Radio />}
                                    label={t('general.remove')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <DialogActions className={e2e?.dialogActions}>
                        <Button
                            className={e2e?.saveButton}
                            type="submit"
                            disabled={show || (inputValue > balance && value === '2')}
                        >
                            {t('general.save')}{' '}
                        </Button>

                        <Button
                            className={e2e?.cancelButton}
                            onClick={() => {
                                onClose();
                                setLoading(false);
                                setShow(false);
                            }}
                        >
                            {t('general.cancel')}{' '}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </form>
        </Dialog>
    );
};
